import {Able, MoveableManagerInterface} from "moveable";
import {Renderer} from "react-moveable/types";
import React from "preact/compat";
import Interactable from "../interactable";
import {ABLE_OFFSET} from "../interactable-constants";

interface AngleViewableProps {
  angleViewable: boolean;
  interactable: Interactable;
}

const AngleViewable = {
  name: "angleViewable",
  always: true,
  props: {
    interactable: Interactable
  },
  render(moveable: MoveableManagerInterface<AngleViewableProps>, _renderer: Renderer) {
    const rect = moveable.getRect();

    const rotation = Math.round(moveable.props.interactable.getFrame().rotate || 0);
    const id = moveable.props.interactable.getElement().attr('id');

    return <div key={`angle-${id}`} className={"moveable-angle"} style={{
      position: "absolute",
      left: `${rect.width / 2}px`,
      top: `${rect.height + ABLE_OFFSET.ANGLE}px`,
      background: "rgba(252,95,87,.75)",
      borderRadius: "2px",
      padding: "2px 4px",
      color: "white",
      fontSize: "13px",
      whiteSpace: "nowrap",
      fontWeight: "bold",
      willChange: "transform",
      transform: "translate(-50%, 0px)",
      display: "none"
    }}>
      {rotation}°
    </div>
  },
} as Able;

export default AngleViewable;
